import { z } from 'zod'

import type { FieldDef } from '@/components/entity-crud'

/** Manufacturers and suppliers share the same contact block. */
export const contactSchema = z.object({
  name: z.string().trim().min(1, 'Give it a name').max(128),
  comment: z.string(),
  website: z.string(),
  email: z.string(),
  phone: z.string(),
  address: z.string(),
  auto_product_url: z.string(),
})

export type ContactValues = z.infer<typeof contactSchema>

export const emptyContact: ContactValues = {
  name: '',
  comment: '',
  website: '',
  email: '',
  phone: '',
  address: '',
  auto_product_url: '',
}

export function toContactValues(row: {
  name: string
  comment: string
  website: string
  email: string
  phone: string
  address: string
  auto_product_url: string
}): ContactValues {
  return {
    name: row.name,
    comment: row.comment,
    website: row.website,
    email: row.email,
    phone: row.phone,
    address: row.address,
    auto_product_url: row.auto_product_url,
  }
}

/**
 * Generic over the form values so a screen that adds its own fields (suppliers)
 * can reuse the block without casting.
 */
export const CONTACT_FIELDS: FieldDef<ContactValues & Record<string, unknown>>[] = [
  { name: 'name', label: 'Name' },
  { name: 'website', label: 'Website', type: 'url', placeholder: 'https://…' },
  { name: 'email', label: 'Email', type: 'email' },
  { name: 'phone', label: 'Phone' },
  { name: 'address', label: 'Address', type: 'textarea' },
  {
    name: 'auto_product_url',
    label: 'Product URL template',
    wide: true,
    placeholder: 'https://example.com/product/%%PARTNUMBER%%',
    description:
      'Used to build a link when a part has no explicit product URL. Must contain %%PARTNUMBER%%.',
  },
  { name: 'comment', label: 'Comment', type: 'textarea' },
]
